export interface CeebSchool {
  zipcode: string; // "33714",
  country: string; // "United States",
  ceeb: string; // "101534",
  street_1: string; // "4500 43rd St N",
  city: string; // "Saint Petersburg",
  zipcode4: string; // "3508",
  county: string; // "Pinellas",
  name: string; // "Broach School Saint Petersburg",
  state: string; // "FL",
  type: string; // "highschool",
  score: number; // 7.7385426
}

export const getSchoolName = (school: Partial<CeebSchool>) => {
  let name = '';
  if (school.name) {
    name += school.name;
  }

  if (school.ceeb) {
    name += ` (${school.ceeb})`;
  }

  return name;
};

export const getSchoolAddress = (school: Partial<CeebSchool>) => {
  const address = [
    school.street_1,
    school.city,
    school.state,
    school.zipcode,
    school.country
  ].filter(Boolean);
  return address.join(', ');
};
